// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-card-header-critical {
  color: #B01C2E !important;
}
.li-no-hover:hover {
  background-color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/app/rule/v2/library-rule-detail.component.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;AADF;AAIA;EACE,yBAAA;AAFF","sourcesContent":["@color-red: #B01C2E;\n\n.container-card-header-critical {\n  color: @color-red !important;\n}\n\n.li-no-hover:hover {\n  background-color: inherit;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
